// Category colors
export const INRIA_COLOR = "#e74836";
export const OTHER_COLOR = "#84B6B4";

// Text colors
export const TEXT_COLOR = "#282929";

// Link colors
export const DEFAULT_LINK_COLOR = "#000000";

export const programColors = {
    'Inria Challenge': '#e63312',
    'Associate Team' : '#ff9100',
    'Codirection of PhD Thesis': '#ffc440',
    'Inria Academy': '#bbe26f',
    'Inria Startup Studio': '#61bc86',
    'Postdoctoral Research Position at Inria': '#52b1ff',
    'Internships and Mobility': '#ad3add',
    'Inria Instruments': ['#c60909', '#ff6700', '#7ee070', '#06ccb4', '#555eff', '#db3b9b'],

    'ANID Funded Programme': '#00bcae',
    'CORFO Funded Programme': '#1456db',
    'FIA Funded Programme': '#ed1568',
    'FIC-R Programme': '#19cc61',
    'International Cooperation': '#c67728',
    'Public Instruments': ['#c67728', '#004cc6', '#bc0852'],

    'R&D Contracts': '#ff0080',
    'IP Royalty Contracts': '#50d3ae',
    'Avina Americas': '#00d5ff',
    'COPEC-UC': '#0080ff',
    'SOFOFA Hub': '#0000ff',
    'Seed Fund Associate Team': '#ff00ff',
    'Private Instruments': ['#c7e010', '#a700ff', '#ff00b1'],

    'Informal Collaboration': '#a5a5a5',
    'Internal Project': '#660066',
    'Mesa de Trabajo': '#001384',
    'Directory': '#444444',
    'Other': ['#6172ba', '#ad5997', '#666666']
}

export const LEVEL0_ARC_COLOR = "#3a4259"
export const COUNTRY_ARC_COLOR = "#647798"
export const CONTINENT_ARC_COLOR = "#384257"
